<template>
  <div>
    <div class="BkHash">
      <div class="BkHash-W">
        <div class="BkHash-Inp"><Homeinput @search="searchs" /></div>
        <div class="BkHash_conent">
          <div class="addflex">
            <div class="BkHash_conent_header">
              <p>
                <span>Address</span
                ><span ref="ele" class="notranslate">{{ address }}</span
                ><img
                  src="../../../assets/pc/Index/fz.png"
                  v-clipboard:copy="address"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  @click="mes"
                />
                <!-- @click="dialogVisible = true" -->
                <!-- <img @click="erm()" src="@/assets/pc/Index/erwm.png" /> -->
              </p>
              <!-- <p v-if="tfscAddress !== '' && tfscAddress !== address">
                <span style="margin-right: 60px">&nbsp;&nbsp;</span>
                <span ref="ele" class="notranslate">{{ tfscAddress }}</span
                ><img
                  src="../../../assets/pc/Index/fz.png"
                  v-clipboard:copy="tfscAddress"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  @click="mes"
                />
               
              </p> -->
            </div>
            <div class="BkHash_conent_Ul">
              <ul>
                <li v-for="(item, index) in list" :key="index">
                  <p>{{ item.Total }}</p>
                  <p class="notranslate">{{ item.Balance }}</p>
                </li>
              </ul>
            </div>
          </div>
          <!-- 二维码弹窗 -->
          <!-- <el-dialog :title="title" :visible.sync="show" width="500px" append-to-body>
      <div style="justify-content: center;align-items: center;display: flex;" ref="qrcode"></div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadCode">下 载</el-button>
        <el-button @click="cancelDownload">取 消</el-button>
      </div>
    </el-dialog> -->
        </div>
        <div class="Transction">
          <div class="Blocks">
            <div class="tabbox">
              <ul>
                <li :class="num == 1 ? 'active' : ''" @click="qiehuan(1)">
                  Transactions ({{ total }})
                </li>
                <li :class="num == 2 ? 'active' : ''" @click="qiehuan(2)">
                  Delegated details
                </li>
                <li :class="num == 3 ? 'active' : ''" @click="qiehuan(3)">
                  Tokens ({{ tokenlength }})
                </li>
                <li :class="num == 4 ? 'active' : ''" @click="qiehuan(4)">
                  NFTS ({{ total4 }})
                </li>
                <li :class="num == 5 ? 'active' : ''" @click="qiehuan(5)">
                  Smart Contracts ({{ list6.length }})
                </li>
                <!-- <li :class="num == 6 ? 'active' : ''" @click="qiehuan(6)">
                  Analysis
                </li> -->
              </ul>
            </div>
            <!-- <div class="Block_Top">
              <span
                >Transactions<b class="notranslate">({{ total }})</b></span
              >
              <span class="notranslate">
                <el-pagination
                  ref="Pagination"
                  :current-page.sync="PaginationIndex"
                  background
                  layout="prev, pager,next"
                  @current-change="CurrentChange"
                  :total="total"
                >
                </el-pagination>
              </span>
            </div> -->
            <div v-show="num == 1">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>Hash</li>
                  <li class="xila">
                    <div @click="dianji">
                      Type
                      <!-- <img src="@/assets/pc/TopValidators/xiala2.png" /> -->
                    </div>
                    <!-- <div class="xiala" v-show="valShow">
                      <div
                        class="xialalist"
                        v-for="(item, index) in calendarDatas"
                        :key="index"
                      >
                        <p
                          @click="getTypeTxsList(item)"
                          :class="index == itemindex ? 'active' : ''"
                        >
                          {{ item.name }}
                        </p>
                      </div>
                    </div> -->
                  </li>
                  <li>Age</li>
                  <li>From</li>
                  <li>To</li>
                  <li>Amount</li>
                  <!-- <li>Gas</li> -->
                </ul>
              </div>
              <div
                class="Block_List_center notranslate"
                v-show="list2.length > 0"
              >
                <ul>
                  <li v-for="(item, index) in list2" :key="index">
                    <p>
                      <span @click="TxHash(index)">
                        {{ getSubStr(item.txHash) }}
                      </span>
                    </p>
                    <p>{{ item.type }}</p>
                    <p>
                      {{ item.tradeTime }}
                    </p>
                    <p>
                      <span
                        @click="Addressa(item.fromAddress1)"
                        v-if="
                          item.type != 'Unstake' &&
                          item.fromAddress != 'Unpledge' &&
                          item.fromAddress1 !== address &&
                          item.type != 'Bonus' &&
                          item.type != 'Commission'
                        "
                      >
                        {{ getSubStr2(item.fromAddress) }}
                      </span>
                      <span class="yanca" v-if="item.type == 'Bonus'"
                        >Bonus</span
                      >
                      <span class="yanca" v-if="item.type == 'Commission'"
                        >Commission</span
                      >
                      <span
                        v-if="
                          item.fromAddress1 == address &&
                          item.type != 'Bonus' &&
                          item.type != 'Commission'
                        "
                        class="yanca"
                      >
                        {{
                          (item.type != "Unstake" &&
                            item.type != "Signature Rewards" &&
                            item.type != "Bonus") ||
                          item.type1 == "8"
                            ? getSubStr2(item.fromAddress)
                            : "Unstake"
                        }}
                      </span>
                      <span
                        v-if="
                          item.type == 'Unstake' &&
                          item.fromAddress1 == 'Unpledge'
                        "
                        class="yanca"
                        >Unstake</span
                      >
                      <span
                        v-if="
                          item.fromAddress1 == 'Unpledge' &&
                          item.type == 'Signature Rewards'
                        "
                        class="yanca"
                        >Unstake</span
                      >
                    </p>
                    <p>
                      <span
                        v-if="
                          item.type == 'Bonus' ||
                          item.type == 'Unstake' ||
                          item.type == 'Withdraw'
                        "
                        >{{ getSubStr3(item.toAddress) }}</span
                      >
                      <span>
                        <span
                          @click="Address2(index)"
                          :class="
                            item.toAddress != 'Gas' &&
                            item.toAddress != 'Stake' &&
                            item.toAddress != address &&
                            item.toAddress !== ''
                              ? 'active'
                              : ''
                          "
                          v-if="
                            (item.type == 'Transfer' ||
                              item.type == 'Trustor stake' ||
                              item.type == 'Withdrawal' ||
                              item.type == 'Delegate' ||
                              item.type == 'Commission' ||
                              item.type1 == 'commission' ||
                              item.type1 == '7' ||
                              item.type1 == '8') &&
                            item.toAddress !== ''
                          "
                          >{{ getSubStr3(item.toAddress) }}</span
                        >
                        <span v-if="item.type == 'Stake'">Stake</span>
                        <span
                          v-if="item.toAddress == ''"
                          style="padding-left: 24px"
                          >....</span
                        >
                      </span>

                      <span v-if="item.type == 'Signature Rewards'"
                        >Signature Rewards</span
                      >
                    </p>
                    <p
                      v-if="item.standard == 'ERC-721' && item.type1 == 7"
                      style="color: #898b8d !important"
                    >
                      <!-- <img :src="item.logo" style="width:24px;height: 24px;" />{{ item.symbol }} #{{
                        item.tokenAmount
                      }} -->
                      <img
                        :src="item.logo"
                        v-if="item.tokenAmount == ''"
                        style="width: 24px; height: 24px; border-radius: 50%"
                      />
                      <img
                        :src="item.logo"
                        v-if="item.tokenAmount !== ''"
                        style="width: 34px; height: 34px; border-radius: 4px"
                      />

                      <span v-if="item.contractName == ''">
                        {{ getSubStr(item.contractAddress, 0, 2) }}</span
                      >
                      <span v-else>{{ item.contractName }}</span>
                    </p>
                    <!-- 代币 -->
                    <p
                      v-if="item.standard == 'ERC-20' && item.type1 == 7"
                      style="color: #fff !important; cursor: pointer"
                      @click="takengo(index)"
                    >
                      <!-- <img :src="item.logo" style="width:24px;height: 24px;" />{{ item.symbol }} #{{
                        item.tokenAmount
                      }} -->
                      <!-- {{ item.tokenAmount }} -->
                      {{
                        new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                          maximumFractionDigits: 10,
                        }).format(item.tokenAmount)
                      }}
                      <!-- {{ Number(item.tokenAmount).toLocaleString() }} -->
                      <img
                        :src="item.logo"
                        style="width: 24px; height: 24px; border-radius: 50%"
                      />
                      <span v-if="item.symbol.trim() !== ''">
                        <span v-if="item.symbol.length > 10"
                          >{{ item.symbol.slice(0, 10) }}...</span
                        >
                        <span v-else>{{ item.symbol }}</span>
                      </span>
                      <span v-else>
                        <span v-if="item.contractName.trim() !== ''">
                          {{ item.contractName }}
                        </span>

                        <span v-else>{{
                          getSubStr(item.contractAddress, 0, 3)
                        }}</span>
                      </span>
                    </p>
                    <p
                      v-if="item.standard == 'ERC-20' && item.type1 == 8"
                      style="
                        color: #fff !important;
                        cursor: pointer;
                        display: flex;
                      "
                      @click="takengo(index)"
                    >
                      <span v-if="item.tokenAmount !== ''">
                        <span v-if="item.tokenAmount.length > 8"
                          ><span v-if="item.tokenAmount > 999"
                            >{{
                              Number(
                                item.tokenAmount.slice(0, 10)
                              ).toLocaleString()
                            }}...</span
                          ><span v-else
                            >{{ item.tokenAmount.slice(0, 8) }}...</span
                          ></span
                        >
                        <span v-else>
                          <!-- {{ Number(item.tokenAmount).toLocaleString() }} -->
                          {{
                            new Intl.NumberFormat("en-US", {
                              minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                              maximumFractionDigits: 10,
                            }).format(item.tokenAmount)
                          }}
                        </span>
                      </span>
                      <img
                        :src="item.logo"
                        style="width: 24px; height: 24px; border-radius: 50%"
                      />
                      <span
                        ><span v-if="item.symbol !== ''">{{ item.symbol }}</span
                        ><span v-else>{{ item.contractName }}</span>
                      </span>
                    </p>
                    <!-- 合约执行 -->
                    <p
                      v-if="
                        item.standard == 'ERC-721' &&
                        item.type1 == 8 &&
                        item.type !== 'balanceOf'
                      "
                      style="display: flex"
                    >
                      <!-- //   item.logo -->

                      <img
                        :src="item.logo"
                        style="
                          border: 1px solid #000;
                          border-radius: 4px;
                          margin-left: 0px;
                        "
                      />

                      <span>
                        <span
                          @click="cHash(index)"
                          v-if="item.nftNameList !== ''"
                          style="cursor: pointer; color: #fff"
                        >
                          {{ item.nftNameList }}</span
                        ><span v-else style="color: #898b8d">{{
                          item.contractName
                        }}</span>
                      </span>
                      <span
                        v-if="item.tokenAmount !== 0"
                        @click="cHash(index)"
                        style="cursor: pointer"
                      >
                        <!-- {{ item.tokenAmount }} -->
                        {{ item.tokenAmount }}
                      </span>
                      <!-- {{
                        item.tokenAmount
                      }} <img :src="item.logo"  style="width:24px;height: 24px; border-radius: 50%;"/>{{ item.contractName }}  -->
                    </p>
                    <p
                      v-if="
                        item.standard == 'ERC-721' &&
                        item.type1 == 8 &&
                        item.type == 'balanceOf'
                      "
                      style="color: #8d8d8d"
                    >
                      <!-- //   item.logo -->
                      <img
                        :src="item.logo"
                        style="width: 24px; height: 24px; border-radius: 4px"
                        v-if="item.tokenAmount == ''"
                      />
                      <img
                        :src="item.logo"
                        style="border-radius: 4px"
                        v-if="item.tokenAmount !== ''"
                      />{{ item.contractName }} {{ item.nftNameList }}
                      <!-- {{ Number(item.tokenAmount).toLocaleString() }} -->
                      {{
                        new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                          maximumFractionDigits: 10,
                        }).format(item.tokenAmount)
                      }}
                      <!-- {{
                        item.tokenAmount
                      }} <img :src="item.logo"  style="width:24px;height: 24px; border-radius: 50%;"/>{{ item.contractName }}  -->
                    </p>
                    <p
                      v-if="
                        (item.type1 !== 8 || item.type1 !== 7) &&
                        item.standard == ''
                      "
                      style="color: #898b8d !important"
                    >
                      <!-- {{ Number(item.amount).toLocaleString() }} -->
                      {{
                        new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                          maximumFractionDigits: 10,
                        }).format(item.amount)
                      }}
                      TTOS
                    </p>
                    <!-- <p>
                      <img src="../../../assets/pc/Index/amount.png" />{{
                        item.amount
                      }}
                      TTOS
                    </p> -->
                    <!-- <p>{{ item.gas }} TTOS</p> -->
                  </li>
                </ul>
              </div>
              <!-- class="Block_List_Bottom notranslate" -->
              <div
                :class="list2.length > 10 ? 'Block_List_Bottom' : ''"
                v-show="list2.length > 0"
              >
                <el-pagination
                  ref="Pagination"
                  :current-page.sync="PaginationIndex"
                  background
                  :page-size="20"
                  layout="prev, pager,
      next"
                  @current-change="CurrentChange"
                  :total="total"
                >
                </el-pagination>
              </div>

              <div v-show="list2.length <= 0">
                <EmptyState />
              </div>
            </div>
            <div v-show="num == 2">
              <div
                :class="
                  list3.length > 10 ? 'Delegated_listbox' : 'Delegated_listboxa'
                "
              >
                <div class="Delegated_list">
                  <div class="Delegated_top">
                    <ul>
                      <li>Investment account (from)</li>
                      <li>Investment account (To)</li>
                      <li>Investment amount</li>
                      <li>Age</li>
                    </ul>
                  </div>
                  <div class="Delegated_center" v-if="list3.length > 0">
                    <!-- <div
                      class="Delegated_box"
                      v-for="(item, index) in list3"
                      :key="index"
                    > -->
                    <div
                      class="Delegated_box"
                      v-for="(item, index) in list3"
                      :key="index"
                    >
                      <div
                        v-if="item.fromAddress == address"
                        class="Delegated_li"
                        style="color: #898b8d"
                      >
                        {{ item.fromAddress1 }}
                      </div>
                      <div v-else class="Delegated_li" @click="addressf(index)">
                        {{ item.fromAddress1 }}
                      </div>
                      <div
                        class="Delegated_li"
                        style="color: #898b8d"
                        v-if="item.toAddress == address"
                      >
                        {{ item.toAddress1 }}
                      </div>
                      <div v-else class="Delegated_li" @click="addresst(index)">
                        {{ item.toAddress1 }}
                      </div>
                      <div class="Delegated_li">
                        <!-- {{ Number(item.amount).toLocaleString() }} -->
                        {{
                          new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                            maximumFractionDigits: 10,
                          }).format(item.amount)
                        }}

                        TTOS
                      </div>
                      <div class="Delegated_li">{{ item.tradeTime }}</div>
                    </div>
                  </div>
                  <!-- <div class="Delegated_bottom"> -->
                  <div
                    :class="list3.length > 10 ? '' : 'Block_List_Bottom'"
                    style="margin-top: 28px !important"
                    v-show="list3.length > 0"
                  >
                    <el-pagination
                      ref="Pagination"
                      :current-page.sync="PaginationIndex1"
                      :page-size="20"
                      background
                      layout="prev, pager,
      next"
                      @current-change="CurrentChangea"
                      :total="total3"
                    >
                    </el-pagination>
                  </div>
                  <div v-show="list3.length <= 0">
                    <EmptyState />
                  </div>
                </div>
              </div>
              <!-- </div> -->
            </div>
            <div v-show="num == 3">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>Asset</li>

                  <li>Contract Address</li>
                  <li>Quantity</li>
                </ul>
              </div>
              <div
                class="Block_List_center notranslate"
                v-show="list4.length > 0"
              >
                <ul>
                  <li v-for="(item, index) in list4" :key="index">
                    <p @click="AddressTaken(item.contractAddresss)">
                      <img
                        :src="item.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          border-radius: 50%;
                          margin-top: 16px;
                        "
                      />
                      {{ item.contractName }}
                    </p>
                    <p
                      @click="AddressTaken(item.contractAddress)"
                      style="cursor: pointer"
                    >
                      {{ item.contractAddress }}
                    </p>

                    <p>
                      {{
                        new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                          maximumFractionDigits: 10,
                        }).format(item.balance)
                      }}
                    </p>
                    <!-- <p>{{ item.gas }} TTOS</p> -->
                  </li>
                </ul>
              </div>
              <div
                class="Block_List_Bottom notranslate"
                v-show="list4.length > 0"
              >
                <el-pagination
                  ref="Pagination"
                  :current-page.sync="PaginationIndex3"
                  background
                  layout="prev, pager,
      next"
                  @current-change="CurrentChange"
                  :total="tokenlength"
                >
                </el-pagination>
              </div>
              <div v-show="list4.length <= 0">
                <EmptyState />
              </div>
            </div>
            <div v-show="num == 4">
              <div class="NFTS_list">
                <div
                  class="NFTS_box"
                  v-for="(item, index) in list5"
                  :key="index"
                >
                  <div class="NFTS_li">
                    <img :src="item.image" />
                    <!-- <ele-image
                    :size="100"
                    :src="item.image"
                  /> -->
                  </div>
                  <div class="NFTS_lis">
                    <div class="NFTS_tit" @click="Tacke(index)">
                      Token:<span
                        style="cursor: pointer"
                        v-if="item.contractName !== ''"
                        >{{ item.contractName }}</span
                      >
                      <span v-else style="cursor: pointer">{{
                        getSubStr(item.contractAddress, 0, 3)
                      }}</span>
                    </div>
                    <div class="NFTS_cont">
                      TokenID:<span
                        style="cursor: pointer"
                        @click="TackeId(index)"
                        >{{ item.tokenId }}</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="Block_List_Bottom"
                  style="margin-top: 0px"
                  v-show="list5.length > 0"
                >
                  <el-pagination
                    ref="Pagination"
                    :current-page.sync="PaginationIndex5"
                    background
                    :page-size="24"
                    layout="prev, pager,
      next"
                    @current-change="CurrentChange1"
                    :total="total4"
                  >
                  </el-pagination>
                </div>
              </div>
              <div v-show="list5.length <= 0">
                <EmptyState />
              </div>
            </div>
            <div v-show="num == 5">
              <div v-if="this.list6.length > 0">
                <div class="Contract5">
                  <div class="Contract5_l">Contract :</div>
                  <div class="Contract5_r">
                    <el-select @change="changevale" v-model="selectedOption">
                      <el-option
                        v-for="item in options"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!-- 合约验证开始 -->
                <div class="Contract6">
                  <div v-if="isChecked == 0">
                    <div class="ContractName">
                      <div class="Contracttit">
                        <img :src="imgnamea" />
                        <div>
                          Contract source code is unverified.l am the creator of
                          the contract,<span @click="goto"
                            >Verify and launch source code</span
                          >
                        </div>
                      </div>
                    </div>
                    <!-- <div class="ContractName">
                      <div class="Contracttits">Contract Name :</div>
                      <div class="Contractconts">1111</div>
                    </div>
                    <div class="ContractName">
                      <div class="Contracttits">Compiler Version :</div>
                      <div class="Contractconts">null</div>
                     
                    </div> -->
                  </div>
                  <div v-if="isChecked == 1">
                    <div class="ContractName">
                      <div class="Contracttit">
                        <img :src="imgname" />
                        <div>Contract Source Code Verified (Exact Match)</div>
                      </div>
                    </div>
                    <div class="ContractName">
                      <div class="ContractNamebox">
                        <div class="Contracttits">Contract Name :</div>
                        <div class="Contractconts">{{ contractName }}</div>
                      </div>
                    </div>
                    <div class="ContractName">
                      <div class="ContractNamebox">
                        <div class="Contracttits">Compiler Version :</div>
                        <div class="Contractconts">{{ allVersion }}</div>
                      </div>
                      <div class="ContractNamebox">
                        <div
                          class="Contracttits"
                          style="width: 97px !important"
                        >
                          License :
                        </div>
                        <div class="Contractconts">{{ license }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 合约验证结束 -->
                <div
                  class="Contract5_tit"
                  v-if="code.length > 0 && isChecked == 1"
                >
                  <div class="Contract5_titl">contract source code</div>
                  <div class="Contract5_titr">
                    <img
                      v-clipboard:copy="code"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      src="@/assets/pc/charts/copy.png"
                    />
                    <!-- <img src="@/assets/pc/charts/link.png" />
                  <img src="@/assets/pc/charts/fang.png" /> -->
                  </div>
                </div>
                <div
                  class="codeEditBox"
                  ref="returnTop"
                  v-if="code.length > 0 && isChecked == 1"
                >
                  <editor
                    v-model="code"
                    @init="editorInit"
                    @input="codeChange"
                    lang="javascript"
                    :options="editorOptions"
                    theme="vibrant_ink"
                    id="codeEditBox"
                  ></editor>
                </div>
                <div class="Contract5_tit">
                  <div class="Contract5_titl">Bytecode</div>
                  <div class="Contract5_titr">
                    <img
                      v-clipboard:copy="code1"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      src="@/assets/pc/charts/copy.png"
                    />

                    <!-- <img src="@/assets/pc/charts/link.png" />
                  <img src="@/assets/pc/charts/fang.png" /> -->
                  </div>
                </div>
                <div class="codeEditBox">
                  <editor
                    v-model="code1"
                    @init="editorInit"
                    @input="codeChange"
                    lang="java"
                    :options="editorOptions"
                    theme="vibrant_ink"
                  ></editor>
                </div>
              </div>
              <div v-else>
                <EmptyState />
              </div>
            </div>
            <!-- <div v-show="num == 6">
              <div class="Analysis_list">
                <div class="charts">
                  <div class="charts_title">TTOS Balance</div>
                  <div
                    id="charts"
                    ref="chart"
                    style="width: 1160px; height: 260px"
                  ></div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Editor from "vue2-ace-editor";
//黑底色
import "brace/theme/tomorrow_night_eighties";
//蓝底色
import "brace/theme/tomorrow_night_blue";
//黑底色
import "brace/theme/vibrant_ink";
import Homeinput from "../Home/Home_input.vue";
import BlocksList from "../BlockList/BlocksList";
import EmptyState from "../EmptyState/EmptyState.vue";
import Pagination3 from "../BlockList/Pagination3.vue";
import {
  AddressDetail,
  AddressDetaillist,
  TypeTxsList,
  GetaddressTypeList,
  GettokenList,
} from "@/assets/server/api";
import {
  formatSeconds,
  listType,
  getSubStr,
  countDecimalPlaces,
  formattedNumber,
} from "@/utils/utils";
const echarts = require("echarts");
export default {
  data() {
    return {
      tokenlength:'',
      qrCodes: "",
      list: [
        {
          Total: "Total Balance :",
          Balance: "0 TTOS",
        },
        {
          Total: "Available :",
          Balance: "0 TTOS",
        },
        {
          Total: "TTOS Staked :",
          Balance: "0",
        },
        {
          Total: "TTOS Delegated :",
          Balance: "0",
        },
        {
          Total: "Transactions :",
          Balance: "0",
        },
        {
          Total: "Earned Bonus :",
          Balance: "0 TTOS",
        },
      ],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],
      calendarDatas: [
        {
          name: "ALL",
          value: "",
          id: 0,
        },
        {
          name: "Transfer",
          value: 1,
          id: 1,
        },
        {
          name: "Bonus",
          value: "toAward",
          id: 2,
        },
        {
          name: "Delegate",
          value: 4,
          id: 3,
        },
        {
          name: "Withdraw",
          value: 5,
          id: 4,
        },
        {
          name: "Stake",
          value: 2,
          id: 5,
        },
        {
          name: "Unstake",
          value: 3,
          id: 6,
        },
        {
          name: "Commission",
          value: "Commission",
          id: 7,
        },
      ],
      copyContent: "",
      PaginationIndex: 1,
      PaginationIndex1: 1,
      PaginationIndex2: 1,
      PaginationIndex3: 1,
      PaginationIndex5: 1,
      tradeNums: "",
      total: null,
      total2: null,
      total3: null,
      total4: null,
      Type: [],
      txHash: [],
      fromAddress: [],
      toAddress: [],
      data: [],
      data2: [],
      data3: [],
      ToList: 0,
      Time: [],
      address: "",
      // tfscAddress: "",
      Page1: "",
      TimeDate: [],
      value: "Type",
      itemindex: 0,
      IsShow: false,
      valShow: false,
      itemtype: "",
      itemall: "",
      typeli: 1,
      num: 1,
      dialogVisible: true,
      code: "",
      code1: "",
      imgname: require("@/assets/pc/TopValidators/TopValidators4.png"),
      imgnamea: require("@/assets/pc/TopValidators/tan.png"),
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
      imgurlnft: require("@/assets/pc/Index/nft.png"),
      imgurl1: require("@/assets/pc/Index/amount.png"),
      editorOptions: {
        wrap: true,
        // 设置代码编辑器的样式
        enableBasicAutocompletion: true, //启用基本自动完成
        enableSnippets: true, // 启用代码段
        //  enableLiveAutocompletion: true, //启用实时自动完成
        tabSize: 0, //标签大小
        fontSize: 14, //设置字号
        readOnly: true,
        showPrintMargin: false, //去除编辑器里的竖线
        wrapBehavioursEnabled: true, //启用换行
        // autoScrollEditorIntoView: false, //启用滚动
        showFoldWidgets: true, // 显示折叠部件
        fadeFoldWidgets: true, // 淡入折叠部件
        hScrollBarAlwaysVisible: false, //纵向滚动条始终可见
        vScrollBarAlwaysVisible: false, // 横向滚动条始终可见
      },
      options: [],
      selectedOption: null,
      flog: false,
      qrcode: null, // 二维码
      show: false,
      title: "",
      isChecked: "",
      license: "",
      compileVersion: "",
      contractName: "",
      allVersion: "",
    };
  },
  components: {
    Homeinput,
    BlocksList,
    EmptyState,
    Pagination3,
    Editor,
  },
  created() {
    this.itemindex = 0;

    // this.code = {
    //   shortcuts: [
    //     {
    //       text: "最近一周",
    //       obj: {},
    //     },
    //     {
    //       text: "最近一个月",
    //       obj: {},
    //     },
    //     {
    //       text: "最近三个月",
    //       obj: {},
    //     },
    //   ],
    // };
    // vue2-ace-editor无法帮你格式化代码
    // this.code = JSON.stringify(this.code, null, 2); // 格式化
    // this.QR();
  },
  mounted() {
    // this.initCharts();
    if (this.num == 1) {
      this.itemtype = "transactions";
      this.PaginationIndex = 1;
      this.getTransactions();
    } else if (this.num == 2) {
      this.PaginationIndex1 = 1;
      this.itemtype = "delegatedDetails";
      this.getTransactions();
    } else if(this.num == 3){
      this.GettokenLists();
    } 
    else if (this.num == 4) {
      this.PaginationIndex5 = 1;
      this.getNftDetail();
    }
    // this.changevale();

    // this.getNftDetail();
  },
  watch: {
    // deep: true,
    $route: {
      handler: function (to) {
        // console.log(to);
        this.address = to.query.query;
        this.PaginationIndex = 1;
        //  console.log(this.address);
        // this.num=to.query.num;
        if (to.query.num == 5) {
          this.num = 5;
        }
        // console.log(this.num);
        if (this.address == "") {
          return false;
        }
        this.address = this.address.split(",")[0];
        //  console.log(this.address);
        sessionStorage.removeItem("tiaozhuan");
        this.itemtype = 0;
        this.itemindex = 0;
        this.valShow = false;
        if (this.num == 1) {
          this.itemtype = "transactions";
          this.PaginationIndex = 1;
          this.getTransactions();
        } else if (this.num == 2) {
          this.PaginationIndex1 = 1;
          this.itemtype = "delegatedDetails";
          this.getTransactions();
        } else if (this.num == 3) {
          this.GettokenLists();
        } else if (this.num == 4) {
          this.PaginationIndex5 = 1;
          this.getNftDetail();
        }
        this.addressDetail();
        // this.getTransactions();
        //  this.getNftDetail();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  methods: {
    goto() {
      this.$router.push("/pc/Verify");
      // this.$message("Coming Soon");
    },
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    erm() {
      this.$nextTick(function () {
        this.onItemClick();
      });
    },
    //生成二维码
    onItemClick() {
      this.show = true;
      this.title = "二维码";
      this.$refs.qrcode.innerHTML = ""; //清空二维码,避免生成多个二维码
      this.$nextTick(() => {
        this.qrcode = new QRCode(this.$refs.qrcode, {
          text: this.address, // 替换为你要生成二维码的内容
          width: 200,
          height: 200,
        });
      });
    },

    //下载二维码
    downloadCode() {
      let that = this;
      //获取二维码中格式为imag的元素
      const nodeList = Array.prototype.slice.call(that.qrcode._el.children);
      const img = nodeList.find(
        (item) => item.nodeName.toUpperCase() === "IMG"
      ); // 选出图片类型
      // 构建画布
      let canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext("2d").drawImage(img, 0, 0);
      // 构造url
      let url = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = url;
      a.download = `二维码.png`;
      // 触发a链接点击事件，浏览器开始下载文件
      a.click();
    },

    // 取消
    cancelDownload() {
      this.show = false;
      this.$refs.qrcode.innerHTML = ""; //清空二维码,避免生成多个二维码
    },
    shengcheng() {
      this.flog = true;
      this.dialogVisible = true;
      this.$nextTick(function () {
        this.QRM();
      });
      // this.creatQrCode('qrcode', '测试内容');
      //   console.log(111);
    },
    takengo(index) {
      let params = {
        contractAddress: this.list2[index].contractAddress,
      };
      this.$router.push({ path: "/pc/Overview", query: params });
    },
    cHash(index) {
      if (
        this.list2[index].type1 == 8 &&
        this.list2[index].standard == "ERC-721"
      ) {
        let params = {
          contractAddress: this.list2[index].contractAddress,
          tokenId: this.list2[index].tokenAmount,
        };
        //   console.log(params);
        this.$router.push({ path: "/pc/NFTslistdetail", query: params });
      }
    },
    addressf(index) {
      //  console.log(index);
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: this.list3[index].fromAddress },
      });

      //   let params = {
      //     contractAddress: index
      //   };
      //   console.log(params);
      //   this.$router.push({ path: "/pc/Overview", query: params });
    },
    addresst(index) {
      // console.log(index);
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: this.list3[index].toAddress },
      });
    },

    // 生成二维码
    // creatQrCode(refName, text) {
    //     if (document.getElementById(refName)) {
    //         document.getElementById(refName).innerHTML = ''; //防止重复生成二维码
    //         this.$nextTick(function () {
    //             new QRCode(document.getElementById(refName), {

    //                     width: 140, //二维码宽度，单位像素
    //                   height: 140, //二维码高度，单位像素
    //                   colorDark: "#000000", //前景色
    //                   colorLight: "#ffffff", //背景色
    //                   correctLevel: QRCode.CorrectLevel.H, //容错级别，
    //                   text: this.Address, //二维码内容：二维码扫描之后访问的地址
    //             })
    //         })
    //     }
    // },

    // QR() {
    //   this.$nextTick(() => {
    //     this.QRM();
    //   });
    // },
    //  生成二维码
    QRM() {
      if (this.address != undefined) {
        this.Address = this.address;
        //console.log(this.Address);
      } else {
        this.Address = this.address;
        // console.log(this.Address);
      }
      //   console.log(document.getElementById("#qrCode"));
      //   console.log(this.$refs.qrCode);
      // console.log("ADdress", Address);
      let qrCode = new QRCode("qrCode", {
        width: 140, //二维码宽度，单位像素
        height: 140, //二维码高度，单位像素
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        correctLevel: QRCode.CorrectLevel.H, //容错级别，
        text: this.Address, //二维码内容：二维码扫描之后访问的地址
      });
      //    console.log(qrCode);
      qrCode.clear(); //清除二维码 。
      qrCode.makeCode(this.Address); //设置二维码内容text，生成另一个新的二维码。
      //    this.qrCodes.clear(); //清除二维码 。
      // this.qrCodes.makeCode(this.Address); //设置二维码内容text，生成另一个新的二维码。
    },
    savePic() {
      let qrCodeCanvas = document
        .getElementById("qrcode")
        .getElementsByTagName("canvas");
      let a = document.createElement("a");
      a.href = qrCodeCanvas[0].toDataURL("image/url");
      a.download = `【${this.$microWidgetProps.contextMenu.getSelections[0].name}】二维码.png`;
      a.click();
    },
    changevale() {
      //this.$refs.returnTop.scrollTop = 0;
      //     console.log("Starting search for:", this.selectedOption);
      //     console.log(this.$refs.returnTop.scrollTop);
      // console.log(this.list6);
      for (var i = 0; i < this.list6.length; i++) {
        if (this.selectedOption == this.list6[i].contractAddress) {
          this.code = this.list6[i].sourceCode;
          this.code1 = this.list6[i].byteCode;
          this.isChecked = this.list6[i].isChecked;
          this.license = this.list6[i].licence;
          this.compileVersion = this.list6[i].compileVersion;
          this.allVersion = this.list6[i].allVersion;
          if (this.list6[i].contractName == "") {
            this.contractName = getSubStr(this.list6[i].contractAddress, 0, 6);
          } else {
            this.contractName = this.list6[i].contractName;
          }
        }
      }

      // window.scrollTo(0, document.getElementById("codeEditBox").scrollTop);
      // Your search logic here
    },
    codeChange(val) {
      // val;
      // this.$refs.returnTop.scrollTop = 0 + "px";
      //  editor.gotoLine(1);
      //    console.log(this.$refs.returnTop.scrollTop);
      //console.log(val)
    },
    editorInit() {
      require("brace/theme/chrome");
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/yaml");
      require("brace/mode/json");
      require("brace/mode/less");
      require("brace/snippets/json");
      require("brace/mode/lua");
      require("brace/snippets/lua");
      require("brace/mode/javascript");
      require("brace/snippets/javascript");
    },
    qiehuan(index) {
      this.num = index;
      if (this.num == 1) {
        this.itemtype = "transactions";
        this.PaginationIndex = 1;
        this.getTransactions();
        this.addressDetail();
      } else if (this.num == 2) {
        this.PaginationIndex1 = 1;
        this.itemtype = "delegatedDetails";
        this.getTransactions();
      } else if (this.num == 3) {
        this.GettokenLists();
      } else if (this.num == 4) {
        this.PaginationIndex5 = 1;
        this.getNftDetail();
      }
    },
    handleClose() {
      this.flog = false;
    },

    dianji() {
      if (this.IsShow == false) {
        this.IsShow = true;
        this.valShow = true;
      } else if (this.IsShow == true) {
        this.IsShow = false;
        this.valShow = false;
      }
    },
    async GettokenLists() {
      let formData = new FormData();
      let params = {
        address: this.address,

        pageNum: this.PaginationIndex3,
        pageSize: 20,
      };
      //     console.log(params);
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GettokenList(formData);
     // console.log(res);
      this.list4 = res.result;
      this.tokenlength=res.result.length;
        // console.log(this.list4);
        for (var i = 0; i < this.list4.length; i++) {
          if (this.list4[i].logo == "") {
            this.list4[i].logo = this.imgurl;
          }
          if (this.list4[i].contractName == "") {
            this.list4[i].contractName = this.list4[i].symbol;
          }
        }
    },
    async getTransactions() {
      //    console.log(this.num);
      if (this.num == 1) {
        this.PaginationIndex = this.PaginationIndex;
        //this.itemtype = "transactions";
      } else if (this.num == 2) {
        this.PaginationIndex = this.PaginationIndex1;
        // this.itemtype = "delegatedDetails";
      }
      //   console.log(this.PaginationIndex);
      let formData = new FormData();
      let params = {
        address: this.address,
        listType: this.itemtype,
        pageNum: this.PaginationIndex,
        pageSize: 20,
      };
      //     console.log(params);
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetaddressTypeList(formData);
      // console.log(res);
   
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      if (this.num == 1) {
        //   var res = await GetaddressTypeList(formData);

        this.list2 = res.result.list;
        // this.list2[i].type1 = (this.list2[i].type);
        // this.list2[i].type = listType(this.list2[i].type);
        //      console.log(this.list2);
        this.total = res.result.count;
        this.total4 = res.result.nftCount;
        //     console.log(this.total);
        for (var i = 0; i < this.list2.length; i++) {
          //     let UTCTime = this.list2[i].tradeTime - this.getClientTimezone * 3600000;
          // if(this.list2[i].logo==''|| this.list2[i].logo==null ){
          //   this.list2[i].logo = this.imgurl1;
          // }
          let timestamp = Math.floor(
            this.gltime(this.list2[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          if (
            this.list2[i].standard == "ERC-721" &&
            this.list2[i].nftImageList !== "" &&
            this.list2[i].type == 8
          ) {
            var images = JSON.parse(this.list2[i].nftImageList);
            // console.log(images);
            this.list2[i].logo = images[0];
            // if (this.check_is_img(this.list2[i].logo) == false) {
            //   this.list2[i].logo = this.imgurl1;
            // }
            // this.list2[i].logo = this.imgurl1;
          } else {
            if (
              this.list2[i].standard == "ERC-721" &&
              this.list2[i].type == 8
            ) {
              this.list2[i].logo = this.imgurlnft;
            }
          }
          // if((this.list2[i].type==8 && this.list2[i].standard == "ERC-721" ) || this.check_is_img(this.list2[i].logo)==false ||this.list2[i].logo==''){
          //   console.log(111);
          //   this.list2[i].logo = this.imgurlnft;
          // }
          if (this.list2[i].nftNameList !== "") {
            this.list2[i].nftNameList = JSON.parse(
              this.list2[i].nftNameList
            )[0];
          }
          //       console.log(this.list2[i].nftImageList);
          // if(this.list2[i].nftImageList !=='' || this.list2[i].nftImageList !==null){
          //   console.log(JSON.parse(this.list2[i].nftImageList)[0]);
          // }

          // this.list2[i].tokenAmount = this.list2[i].tokenAmount.split(",")[0];
          // if(this.list2[i].fromAddress=='' || this.list2[i].toAddress==''){
          //   this.list2[i].fromAddress=='...'
          // }
          this.list2[i].tradeTime = formatSeconds(s);
          this.list2[i].type1 = this.list2[i].type;
          if (this.list2[i].type1 == "8") {
            //         console.log("888888");
            this.list2[i].type = this.list2[i].functions;
          }
          if (this.list2[i].type1 == "8") {
            //          console.log("99999999");
            this.list2[i].fromAddress = this.list2[i].fromEvmAddress;
            this.list2[i].toAddress = this.list2[i].toEvmAddress;
          }
          this.list2[i].fromAddress1 = this.list2[i].fromAddress;
          this.list2[i].toAddress1 = this.list2[i].toAddress;
          this.list2[i].fromAddress = getSubStr(
            this.list2[i].fromAddress,
            0,
            6
          );

          this.list2[i].type = listType(this.list2[i].type);
          if (this.list2[i].type == "mint") {
            this.list2[i].tokenAmount = this.list2[i].tokenAmount.split(",")[0];
          } else {
            // if(this.list2.tokenAmount.length>10){
            //  this.list2[i].tokenAmount =_this.list[i].tokenAmount.slice(0,8)+'...';
            // }
            // if (countDecimalPlaces(this.list2[i].tokenAmount) > 8) {
            //   this.list2[i].tokenAmount = Number(
            //     this.list2[i].tokenAmount
            //       .split(",")[0]
            //       .toString()
            //       .match(/^\d+(?:\.\d{0,8})?/)
            //   );
            // }
          }
          if (this.list2[i].standard !== "ERC-20" && this.list2[i].logo == "") {
            if (this.list2[i].type1 == 7) {
              this.list2[i].logo = this.imgurl;
            } else {
              this.list2[i].logo = this.imgurlnft;
            }
          }
          if (
            this.list2[i].standard == "ERC-20" &&
            (this.list2[i].logo == "" ||
              this.check_is_img(this.list2[i].logo) == false)
          ) {
            if (this.list2[i].logo !== "") {
              this.list2[i].logo = this.list2[i].logo;
            } else {
              this.list2[i].logo = this.imgurl;
            }
            //         console.log(123);
          }
          //判断当为type为7的时候standard为ERC-721

          // if((this.list2[i].standard == "ERC-721" && this.list2[i].type==7) &&this.list2[i].contractName ==""){
          //    console.log(123);
          //    if(this.list2[i].contractName ==""){
          //     this.list2[i].contractName =getSubStr(this.list2[i].contractAddress,0,3)
          //    }
          // }
          //  else{
          //   this.list2[i].logo =  this.list2[i].logo ;
          //  }
          //  if((this.list2[i].standard =='ERC-721' && this.list2[i].type1==7 )&&( this.list2[i].logo=='' || this.check_is_img(this.list2[i].logo)==false)){

          //   this.list2[i].logo = this.imgurl;
          //  }
          //  if(this.list2[i].standard =='ERC-721' && ( this.list2[i].logo=='' || this.check_is_img(this.list2[i].logo)==false)){

          //   this.list2[i].logo = this.imgurl;
          //  }
          //  if((this.list2[i].logo==''&& this.list2[i].type1=='mint') || this.check_is_img(this.list2[i].logo)==false){
          //   console.log(111);
          //   this.list2[i].logo = this.imgurl;
          // }
          if (this.list2[i].toAddress == "Pledge") {
            this.list2[i].toAddress = "Stake";
          }
        }
      } else if (this.num == 2) {
        this.list3 = res.result.list;
        //  console.log(this.list3);
        this.total3 = res.result.count;
        //     console.log(this.list3);
        for (var i = 0; i < this.list3.length; i++) {
          this.list3[i].fromAddress1 = getSubStr(
            this.list3[i].fromAddress,
            0,
            6
          );
          this.list3[i].toAddress1 = getSubStr(this.list3[i].toAddress, 0, 6);
          let timestamp = Math.floor(
            this.gltime(this.list3[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list3[i].tradeTime = formatSeconds(s);
        }
      }
    },
    //   async getTypeTxsList(itemval) {
    //     if (this.IsShow == true) {
    //       this.PaginationIndex = 1;
    //     } else if (this.IsShow == false) {
    //       this.PaginationIndex = this.PaginationIndex;
    //     }

    //     this.typeli = 2;
    //     this.itemall = itemval;
    //     this.valShow = false;
    //     this.IsShow = false;
    //     this.itemindex = itemval.id;
    //     this.itemtype = itemval.value;
    //     let formData = new FormData();
    //     let params = {
    //       address: this.address,
    //       type: this.itemtype,
    //       pageNum: this.PaginationIndex,
    //       pageSize: 10,
    //     };
    //     let item = params;
    //     for (const key in item) {
    //       if (Object.hasOwnProperty.call(item, key)) {
    //         formData.append(key, item[key]);
    //       }
    //     }
    //     var res = await TypeTxsList(formData);
    //     this.list2 = res.result.txList;
    //     this.total = res.result.count;
    // //    console.log(this.total);
    //     var calctime = new Date();
    //     let strdate = Math.floor(calctime.getTime() / 1000);

    //     for (var i = 0; i < this.list2.length; i++) {
    //       let timestamp = Math.floor(this.gltime(this.list2[i].tradeTime) / 1000);
    //       var s = strdate - timestamp;
    //       if (s <= 0) {
    //         s = 1;
    //       }
    //       this.list2[i].tradeTime = formatSeconds(s);
    //       this.list2[i].type = listTypea(this.list2[i].type);
    //     }
    //     this.total = res.result.tradeNums;
    //   },
    async addressDetail() {
      this.typeli = 1;
      if (this.address == "") {
        return false;
      }
      const params = {
        address: this.address,
        // pageNum: this.PaginationIndex,
        // pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      await AddressDetail(formData).then((res) => {
        //  console.log(res);
          this.tokenlength=res.result.tokenCount;
   //   console.log(this.tokenlength);
        // this.tfscAddress = res.result.tfscAddress;
        let ccc = this.add(res.result.available, res.result.tfscStaked);
        let TotalBalance = this.add(ccc, res.result.tfscDelegated);
        //TotalBalance = TotalBalance.toFixed(8);
        this.list[0].Balance = formattedNumber(TotalBalance) + " TTOS";
        this.list[1].Balance = formattedNumber(res.result.available) + " TTOS";
        //      console.log(this.list[1].Balance);
        this.list[2].Balance = formattedNumber(res.result.tfscStaked);

        this.list[3].Balance = formattedNumber(res.result.tfscDelegated);
        this.list[4].Balance = formattedNumber(res.result.txCount);
        // this.list[5].Balance = res.result.earnedBonus;
        if (res.result.earnedBonus == "0.00") {
          this.list[5].Balance = 0;
        } else {
          this.list[5].Balance = formattedNumber(res.result.earnedBonus);
        }
        this.total4 = res.result.nftCount;
        //console.log(this.total4);

        // this.list5 = res.result.nftList;
        // console.log(this.list5);
        // for (var i = 0; i < this.list5.length; i++) {
        //   // this.list5[i].image
        //   if (this.list5[i].image == "") {
        //     this.list5[i].image = this.imgurlnft;
        //   }
        // }
        this.list6 = res.result.contractList;
        //  console.log(this.list6);
        //  this.code = this.list6[2].sourceCode;
        this.options = [];
        if (this.list6.length > 0) {
          this.selectedOption =
            this.list6[this.list6.length - 1].contractAddress;
          for (var i = 0; i < this.list6.length; i++) {
            this.options.push(this.list6[i].contractAddress);
            //          console.log(this.options);
            this.isChecked = this.list6[i].isChecked;
            // console.log(this.isChecked);
            this.license = this.list6[i].licence;
            //   console.log(this.license);
            this.compileVersion = this.list6[i].compileVersion;
            this.allVersion = this.list6[i].allVersion;
            if (this.list6[i].contractName.trim() == "") {
              this.contractName = getSubStr(
                this.list6[i].contractAddress,
                0,
                6
              );
            } else {
              this.contractName = this.list6[i].contractName;
            }
            // this.contractName=this.list6[i].contractName;
            //  console.log(this.contractName);
            // isChecked:"",
            // license:"",
            // compileVersion:"",
            //  this.options=(this.options).reverse();
            this.code = this.list6[i].sourceCode;
            // console.log(this.code);
            this.code1 = this.list6[i].byteCode;
          }
          //       console.log(this.selectedOption);

          // this.code = JSON.stringify(this.list6[2].sourceCode, null, 2); // 格式化
          // console.log(this.code);
        }
      });
    },
    async getNftDetail() {
      let formData = new FormData();
      let params = {
        address: this.address,
        pageNum: this.PaginationIndex5,
        pageSize: 24,
      };
      //   console.log(params);
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await AddressDetaillist(formData);
      //    console.log(res);
      this.total4 = res.result.nftCount;
      this.list5 = res.result.nftList;
      //   console.log(this.list5);
      for (var i = 0; i < this.list5.length; i++) {
        // this.list5[i].image
        if (this.list5[i].image == "") {
          this.list5[i].image = this.imgurlnft;
        }
      }
    },
    TransactionsList2() {
      var calctime = this.gltime();
      let strdate = Math.floor(calctime / 1000);
      for (let i = 0; i < this.list2.length; i++) {
        // let date = [];
        let timestamp = Math.floor(this.list2[i].tradeTime / 1000);
        if (timestamp - strdate > 0) {
          var s = timestamp - strdate;
        } else {
          var s = -(timestamp - strdate); //9.20
        }
        this.list2[i].tradeTime = formatSeconds(s);
      }
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },

    CurrentChange(e) {
      //   console.log(e);
      this.currentPage = 1;

      this.PaginationIndex = e;

      this.addressDetail();
      this.getTransactions();
    },
    CurrentChangea(e) {
      //    console.log(e);
      this.currentPage = 1;

      this.PaginationIndex = e;

      this.getTransactions();
    },
    CurrentChange1(e) {
      this.PaginationIndex = e;
      this.getNftDetail();
    },
    // Addresst(index){
    //   let params = {
    //     contractAddress: index
    //   };
    //   console.log(params);
    //   this.$router.push({ path: "/pc/Overview", query: params });
    // },
    AddressTaken(index) {
      let params = {
        contractAddress: index,
      };
      //  console.log(params);
      this.$router.push({ path: "/pc/Overview", query: params });
    },
    Tacke(Index) {
      let params = {
        contractAddress: this.list5[Index].contractAddress,
      };
      //     console.log(params);
      this.$router.push({ path: "/pc/NFTsdetail", query: params });
    },
    TackeId(Index) {
      //      console.log(Index);
      let params = {
        contractAddress: this.list5[Index].contractAddress,
        tokenId: this.list5[Index].tokenId,
      };
      //     console.log(params);
      this.$router.push({ path: "/pc/NFTslistdetail", query: params });
    },
    TxHash(index) {
      let params = {
        txHash: this.list2[index].txHash,
        type: this.list2[index].type1,
        standard: this.list2[index].standard,
      };
      //     console.log(params);
      this.$router.push({ path: "/pc/To", query: params });
      this.itemindex = 0;
    },
    getSubStr(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    getSubStr2(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    getSubStr3(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    // Delegatedaa(index) {
    //   // alert(111);
    //   console.log(this.list3);
    //   this.$router.push({
    //     path: "/pc/BkHash",
    //     query: { query: index },
    //   });
    // },
    // Delegatedab(index) {
    //   this.$router.push({
    //     path: "/pc/BkHash",
    //     query: { query: this.list3[index].toAddress },
    //   });
    // },
    Addressa(index) {
      //    console.log(this.list2);
      //   console.log(index);
      this.address = index;
      // console.log(this.addr);
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: index },
      });
    },
    Address2(index) {
      //      console.log(this.list2);
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: this.list2[index].toAddress },
      });
    },
    mes() {
      this.$nextTick(() => {
        this.copyContent = this.$refs.ele.innerText.trim();
      });
    },
    onCopy(e) {
      this.$message({
        message: "Copy successful",
        type: "success",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
    add() {
      let _args = arguments;
      let _pointArray = Array.prototype.map.call(_args, (item) => {
        let _itemArray = item.toString().split(".");
        return _itemArray.length > 1 ? _itemArray[1].length : 0;
      });
      let _maxPoint = Math.max.apply(null, _pointArray);
      let _scale = Math.pow(10, _maxPoint);
      return (
        Array.prototype.reduce.apply(_args, [(a, b) => a + b * _scale, 0]) /
        _scale
      );
    },
    searchs(e) {
      //     console.log(e);
      this.address = e.address;
      //     console.log(this.address);
      // this.addressDetail();
      this.itemtype = 0;
      this.itemindex = 0;
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.ace_layer {
  min-height: 520px !important;
  padding-bottom: 10px;
}
/deep/.ace_gutter {
  bottom: none;
  left: none;
}
/* .ace_content {
  height: 500px !important;
} */
/* .el-input--suffix .el-input__inner */
/deep/.ace_gutter-cell.ace_error {
  background-image: none !important;
}
/deep/.ace_gutter-cell.ace_warning {
  background-image: none !important;
}
/deep/.el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #000 !important;
}
/deep/.el-icon-arrow-up:before {
  color: #ffffff;
  font-weight: 900;
}

/deep/.el-select-dropdown__item {
  height: 45px;
  font-size: 15px;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #ffffff;
  line-height: 45px;
}
/deep/.el-scrollbar {
  background: #000;
}
/deep/.el-select-dropdown__list {
  border: none !important;
  background: #0b0c0f;
  /* border-radius: 6px 6px 6px 6px; */
  padding-bottom: 22px;
  opacity: 1;
}
/deep/.el-select-dropdown__item.selected {
  height: 45px;
  background: #1b1e24 !important;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  font-size: 15px;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #00ffaa;
  line-height: 45px;
}

/deep/.el-input__inner {
  background: none;
  border: none;

  font-size: 16px;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #ffffff;
}
/deep/.el-select-dropdown {
  border: none !important;
}

/deep/.el-select-dropdown__item.hover {
  background: #000;
}
/deep/.el-popper[x-placement^="bottom"] .popper__arrow::after {
  background: #1c1e24 !important;
  border-style: none;
}
/deep/::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 20px;
  height: 6px;
  /* border-radius: 24px; */
  background: #13161b;
}
/deep/::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}
/deep/::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 25px;

  background: #404040;
  transition: color 0.2s ease;
}
/deep/::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.codeEditBox {
  width: 1080px;
  margin: 0 auto;
  height: 520px;

  margin-top: 20px;
  background: #0b0c0f;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
}
</style>

<style lang="less" scoped>
/deep/.el-collapse-item__header {
  margin-top: -10px !important;
}
.el-dialog__title {
  margin-left: 80px;
  font-size: 14px;
  font-family: Poppins-Medium, Poppins;
  font-weight: 500;
  color: #898b8d;
}
.v-modal {
  opacity: 0.8 !important;
  background: #13161b !important;
}
.el-dialog {
  background: rgba(0, 0, 0, 0.8);
  // height: 351px !important;
  margin-top: 260px !important;
  left: 100px;
  // width: 339px !important;
}
.el-dialog__body {
  padding: 0 !important;
}
</style>
<style lang="less" scoped>
.ace_gutter-layer {
  background: #0b0c0f !important;
}
.BkHash {
  width: 100%;
  background: #13161b;
  .BkHash-W {
    width: 1200px;
    margin: 0 auto;
    background: #13161b;
    .BkHash-Inp {
      padding: 40px 0;
    }
    .BkHash_conent {
      // border: 1px solid red;
      background: #0b0c0f;
      width: 1160px;
      border-radius: 16px 16px 16px 16px;
      padding: 20px 40px;
      margin-bottom: 20px;
      display: flex;
      .BkHash_conent_header {
        p {
          span {
            display: inline-block;
          }
          span:nth-child(1) {
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
            -webkit-background-clip: text;
          }
          span:nth-child(2) {
            font-size: 16px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #898b8d;
            line-height: 22px;
            -webkit-background-clip: text;
            margin: 0 8px 0 20px;
          }
          img {
            width: 20px;
            height: 20px;
            cursor: pointer;
            margin-right: 10px;
          }
        }
      }
      .BkHash_conent_Ul {
        // display: flex;
        ul {
          li {
            display: flex;
            height: 62px;
            p:nth-child(1) {
              // flex: 0 0 11%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              width: 200px;
              line-height: 62px;
              width: 200px;
              //  display: block;
              //     border: 1px solid green;
            }
            p:nth-child(2) {
              flex: 0 0 60%;
              // border: 1px solid red;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 62px;
            }
          }
        }
      }
      .tankuang {
        // margin-left: 18px;
        width: 339px;
        margin: 0 auto;
        // height: 351px;
        background: rgba(0, 0, 0, 0.8);
        opacity: 1;
        // .tanbox {
        //   display: flex;
        //   margin-top: 20px;
        //   .qrtit {
        //     font-size: 14px;
        //     font-family: Poppins-Medium, Poppins;
        //     font-weight: 500;
        //     color: #898b8d;
        //     margin-left: 107px;
        //   }
        //   .qrimg {
        //     width: 18px;
        //     height: 18px;
        //     margin-left: 66px;
        //     img {
        //       width: 18px;
        //       height: 18px;
        //     }
        //   }
        // }
        .tancontent {
          width: 120px;
          height: 120px;
          margin-left: 107px;
          margin-top: 24px;
          img {
            width: 120px;
            height: 120px;
          }
        }
        .tantit {
          margin-top: 30px;
          margin-left: 20px;
          font-size: 12px;
          font-family: Poppins-Regular, Poppins;
          font-weight: 400;
          color: #898b8d;
        }
        .tancon {
          display: flex;
          width: 299px;
          height: 30px;
          line-height: 30px;
          // border: 1px solid red;
          // background: #13161B;
          margin-left: 20px;
          margin-top: 8px;
          opacity: 1;
          span {
            width: 280px;
            font-size: 12px;
            font-family: Poppins-Regular, Poppins;
            font-weight: 400;
            color: #ffffff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }
          img {
            width: 16px;
            height: 16px;
            margin-top: 6px;
            margin-left: 12px;
          }
        }
        .tanbtn {
          width: 299px;
          height: 30px;
          line-height: 30px;
          background: #13161b;
          opacity: 1;
          margin-left: 20px;
          margin-top: 20px;
          text-align: center;
          font-size: 12px;
          font-family: Poppins-Medium, Poppins;
          font-weight: 500;
          color: #00e79a;
        }
      }
    }
    .Transction {
      // border: 1px solid red;
      width: 1160px;
      border-radius: 16px 16px;
      background: #000;
      // padding-bottom: 36px;
      .tabbox {
        // margin-top: 20px;
        margin-bottom: 20px;
        margin-left: 20px;
        // width: 700px;
        // height: 90px;
        width: 64%;
        background: #1c1e24;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        ul {
          // width: 700px;
          display: flex;
          li:nth-child(1) {
            margin-left: 8px;
          }
          li {
            // width: 144px;
            // border: 1px solid red;
            padding-left: 10px;
            padding-right: 10px;
            height: 54px;
            margin-right: 20px;
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.7);
            // margin: 0px 10px;
            line-height: 54px;
            cursor: pointer;
          }
          .active {
            background: #000000;
            border-radius: 6px 6px 6px 6px;
            margin-top: 6px;
            height: 42px;
            line-height: 42px;
            color: #00a870;
            margin-bottom: 6px;
          }
        }
      }
      .Blocks {
        padding-top: 20px;
        // padding: 20px 20px;
        // height: 1500px;
        background: #000;

        width: 1160px;
        // width: 1160px;
        border-radius: 16px 16px 16px 16px;
        padding-bottom: 40px;
        .Block_Top {
          margin-bottom: 24px;
          display: flex;
          span {
            flex: 1;
          }
          span:nth-child(1) {
            font-size: 16px;
            font-family: SF Pro Text-Medium, SF Pro Text;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.9);

            line-height: 24px;
            -webkit-background-clip: text;
            b {
              margin-left: 4px;
              color: rgba(255, 255, 255, 0.55);
            }
          }
        }
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1120px;

            height: 60px;
            background: #14151a;
            border-radius: 10px 10px 10px 10px;
            margin: 0 auto;
            opacity: 1;
            .xila {
              position: relative;

              img {
                left: 34%;
                top: 30%;
                position: absolute;
                width: 24px;
                height: 24px;
              }
              .xiala {
                width: 97px;
                height: 267px;
                background: #14151a;
                border-radius: 6px 6px 6px 6px;
                opacity: 1;
                position: absolute;
                overflow: hidden;
                -webkit-transition: all 0.3s;
                transition: all 0.3s;
                text-align: center;
                margin-left: 0px;

                .xialalist {
                  cursor: pointer;
                  // margin-left: 13px;
                  p {
                    width: 97px;
                    height: 32px;

                    line-height: 32px;
                    font-size: 16px;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #898b8d;
                  }
                  .active {
                    width: 97px;
                    margin: 0 auto;
                    color: #00a870;
                    text-align: center;
                    height: 32px;
                    background: #000000;
                    border-radius: 6px 6px 6px 6px;
                    opacity: 1;
                  }
                }
              }
            }
            li {
              font-size: 16px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 62px;
              -webkit-background-clip: text;
              flex: 1;
              text-align: left;
              padding-left: 20px;
            }
            li:nth-child(3) {
              flex: 0 0 16.5%;
            }
          }
        }
        .Block_List_center {
          ul {
            // height: 620px;
            padding: 0 20px;
            li {
              display: flex;
              height: 62px;
              border-bottom: 1px solid #22252e;
              line-height: 62px;
              p {
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;

                -webkit-background-clip: text;
                flex: 1;
                text-align: left;
                // margin-left: 20px;
                span {
                  display: inline-block;
                  // width: 150px;
                }
                img {
                  border-radius: 50%;
                }
              }
            }
            li:nth-child(10) {
              // border: none;
            }
            p:nth-child(1) {
              color: #fff;
              cursor: pointer;
            }
            p:nth-child(1):hover {
              color: #00a870;
            }
            p:nth-child(2) {
              color: #fff;
            }
            p:nth-child(2):hover {
              color: #00a870;
            }
            p:nth-child(3) {
              color: #898b8d;
              flex: 0 0 16.5%;
              position: relative;
              padding-left: 20px;
              cursor: default;
              .Hover1 {
                display: none;
                .Hover {
                  width: 196px !important;
                  padding: 3px 10px;
                  display: inline-block;
                  line-height: 20px;
                  position: absolute;
                  top: -10px;
                  left: 00px;
                  background-color: #3c485c;
                  border-radius: 5px;
                  i {
                    position: absolute;
                    top: 18px;
                    left: 40%;
                    transform: rotate(180deg);
                    color: #3c485c;
                  }
                }
              }
            }
            p:nth-child(3):hover {
              .Hover1 {
                display: block !important;
              }
            }
            p:nth-child(4) {
              span {
                color: #fff;
                cursor: pointer;
              }
              .yanca {
                color: #898b8d !important;
                cursor: text;
              }
            }
            p:nth-child(5) {
              color: #898b8d;
            }
            .active {
              color: #fff !important;
              cursor: pointer;
            }
            p:nth-child(6):hover {
              color: #00a870;
            }
            p:nth-child(6) {
              color: rgba(255, 255, 255, 0.9);
              img {
                // width: 24px;
                height: 34px;
                margin-top: 18px;
                margin-right: 0px;
              }
            }
            p:nth-child(7) {
              color: rgba(255, 255, 255, 0.9);
            }
          }
        }
        // 第二部分开始
        .Delegated_listboxa {
          height: 810px !important;
          .Delegated_center {
            height: 600px !important;
          }
        }
        .Delegated_listbox,
        .Delegated_listboxa {
          width: 1160px;
          padding-bottom: 40px;
          min-height: 1310px;
          .Delegated_list {
            width: 1120px;
            height: 60px;
            // border: 1px solid red;
            background: #14151a;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            margin: 0 auto;
            .Delegated_top {
              ul {
                list-style: none;
                display: flex;
              }
              li {
                width: 25%;
                height: 60px;
                line-height: 60px;
                margin-left: 20px;
                font-size: 16px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #898b8d;
              }
            }
            .Delegated_center {
              text-align: left;
              .Delegated_box {
                display: flex;
                // margin-left: 20px;
                border-bottom: 1px solid #22252e;
                height: 60px;
                .Delegated_li {
                  width: 25%;
                  height: 60px;
                  margin-left: 20px;
                  line-height: 60px;
                  font-size: 12px;
                  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                  font-weight: 400;
                  color: #898b8d;
                }
                .Delegated_li:nth-child(1) {
                  color: #fff;
                  cursor: pointer;
                }
                .Delegated_li:nth-child(2) {
                  color: #fff;
                  cursor: pointer;
                }
                .Delegated_li:nth-child(1):hover {
                  color: #00e79a;
                }
                .Delegated_li:nth-child(2):hover {
                  color: #00e79a;
                }
              }
            }
            .Block_List_Bottom {
              padding-top: 610px !important;
              //    width: 1120px;
              // padding-bottom: 36px;
            }
          }
        }
        //第二部分结束
        // 第三部分开始
        .NFTS_list {
          display: flex;
          padding-bottom: 20px;
          flex-wrap: wrap;
          .NFTS_box {
            width: 170px;
            height: 210px;
            margin-right: 20px;
            margin-bottom: 60px;

            .NFTS_li {
              width: 170px;
              height: 181px;
              background: #1c1e24;
              border-radius: 14px 14px 14px 14px;
              opacity: 1;
              margin-left: 20px;
              img {
                width: 170px;
                height: 181px;
                background: #1c1e24;
                border-radius: 14px 14px 14px 14px;
                opacity: 1;
              }
            }
            .NFTS_lis {
              width: 170px;
              margin-top: 12px;
              margin-left: 20px;

              .NFTS_tit {
                height: 17px;
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #898b8d;
                line-height: 17px;
                span {
                  color: #fff;
                  margin-left: 4px;
                }
              }
              .NFTS_cont {
                margin-top: 12px;
                height: 17px;
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #898b8d;
                line-height: 17px;
                span {
                  color: #fff;
                  margin-left: 4px;
                }
              }
            }
          }
        }
        // 第三部分结束
        // 第四部分开始
        .Contract6 {
          width: 1080px;
          margin: 0 auto;
          display: flex;
          flex-direction: column !important;

          // background: #0b0c0f;
          // border-radius: 10px 10px 10px 10px;
          opacity: 1;

          .ContractName {
            display: flex;
            .Contracttit {
              display: flex;

              // margin-bottom: 15px;
              img {
                width: 24px;
                height: 24px;
                margin-right: 8px;
              }
              div {
                height: 20px;
                font-size: 14px;
                font-family: Source Han Sans-Regular, Source Han Sans;
                font-weight: 400;
                color: #898b8d;
                line-height: 20px;
                span {
                  color: #fff;
                  cursor: pointer;
                }
              }
            }
            .Contracttits {
              height: 20px;
              font-size: 14px;
              font-family: Source Han Sans-Regular, Source Han Sans;
              font-weight: 400;
              color: #898b8d;
              line-height: 20px;
              width: 174px;
              margin-top: 28px;
            }
            .Contractconts {
              margin-left: 160px;
              height: 20px;
              font-size: 14px;
              font-family: Source Han Sans-Regular, Source Han Sans;
              font-weight: 400;
              color: #898b8d;
              line-height: 20px;
              margin-top: 28px;
            }
            .ContractNamebox {
              display: flex;
              .Contracttits {
                width: 170px;
                margin-right: 0px;
              }
              .Contractconts {
                margin-left: 0px !important;
                margin-right: 120px;
              }
            }
          }
        }
        .Contract5 {
          width: 1080px;
          margin: 0 auto;
          display: flex;
          margin-bottom: 20px;
          // background: #0b0c0f;
          // border-radius: 10px 10px 10px 10px;
          opacity: 1;

          .Contract5_l {
            margin-top: 8px;
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #898b8d;
          }
          .Contract5_r {
          }
        }
        .Contract5_tit {
          margin-top: 28px;
          display: flex;
          justify-content: space-between;
          .Contract5_titl {
            height: 26px;
            font-size: 18px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            line-height: 26px;
            margin-left: 40px;
          }
          .Contract5_titr {
            margin-right: 40px;
            img {
              width: 28px;
              height: 28px;
              // margin-right: 14px;
            }
          }
        }
        // 第四部分结束
        //第五部分开始
        .Analysis_list {
          width: 1120px;
          height: 359px;
          // background: #1c1e24;
          // border-radius: 10px 10px 10px 10px;
          // opacity: 1;
          margin: 0 auto;
          .charts {
            width: 1120px;
            height: 323px;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            background: #1c1e24;
            padding-bottom: 36px;
            .charts_title {
              height: 26px;
              font-size: 18px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #ffffff;
              line-height: 26px;
              padding-top: 20px;
              margin-left: 20px;
            }
          }
        }
        //第五部分结束
        .Block_List_Bottom {
          //margin-top: 660px;
          margin-top: 30px;
          width: 1120px;
          // padding-bottom: 36px;
        }
      }
    }
  }
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
